import { GET, POST, download, UPLOADINGNEW, uploading, POSTNEW, POSTFormData, EXPORTNEW, uploadingImg, DELETENEW, GETNEW } from '@/request/http'
// 获取类型管理数据
export const punishimentGetTypeManage = p => POST('/studentgrowthfiles/commonType/queryCommonTypeInfo', p)

// 在类型管理内获取动态处分信息
export const typeManageGetPuniData = p => POST('/studentgrowthfiles/commonTypeConfig/queryCommonTypeInfo', p)

// 在类型管理内查询类型数据
export const typeManageGetTypeListData = p => POST('/studentgrowthfiles/commonType/queryCategory', p)

// 在类型管理内查询处分等级列表数据(弃用)
export const typeManageGetGradeListData = p => POST('/studentgrowthfiles/punishmentLevel/querypunishmentLevel', p)

// 处分认定内导入
export const toleadFirmlyBelieveData = p => POSTFormData('/studentgrowthfiles/studentPunishment/import', p)

// 处分认定内导出(弃用)
export const exportFirmlyBelieveData = p => download('/studentgrowthfiles/studentPunishment/exportStudent', p)

// 处分解除内导出(弃用)
export const exportRelieveData = p => download('/studentgrowthfiles/studentPunishment/exportRemoveStudent', p)

// 处分认定内下载模板
export const dowloadFirmlyBelieveData = p => download('/studentgrowthfiles/studentPunishment/template', p)

// 处分认定点击登记或者编辑显示抽屉时获取抽屉内的数据(弃用)
export const firmlyBelieveDrawerData = p => POST('/studentgrowthfiles/studentPunishment/queryPunishmentStudentInfo', p)

// 获取处分配置信息
export const getPunishimentConfigInfo = p => GETNEW('/studentgrowthfiles/punishmentConfig/query', p)

// 处分认定抽屉获取学生信息
export const firmlyBelieveDrawerGetStudentInfo = p => POST('/studentgrowthfiles/studentPunishment/queryStudentId', p)
// 新的处分认定抽屉获取学生信息
export const firmlyBelieveDrawerGetStudentInfoNew = p => POST('/studentgrowthfiles/studentPunishment/queryStudentInfoByNo', p)

// 获取违纪类型
export const firmlyBelieveDrawerGetDisciplineType = p => POST('/studentgrowthfiles/commonType/queryCommonTypeInfo', p)

//上传图片
export const ImageUpload1 = p => uploadingImg('/basic/aliyun-oos/upload-image/punishiment', p, 5)

// 处分认定新增或者修改
export const firmlyBelieveDrawerSubmitData = p => POST('/studentgrowthfiles/studentPunishment/save', p)
// 新的处分认定新增或者修改
export const savePunishInfo = p => POST('/studentgrowthfiles/studentPunishment/savePunishInfo', p)

// 获取页面列表数据
export const firmlyBelieveGetTableData = p => POST('/studentgrowthfiles/studentPunishment/page', p)


// 新的获取页面列表数据
export const tPunishmentStudentInfoList = p => POST('/studentgrowthfiles/studentPunishment/getPunishmentStudentInfoList', p)

// 数据删除
export const firmlyBelieveDelData = p => DELETENEW('/studentgrowthfiles/studentPunishment/delete', p)

// 处分认定详情页提交(弃用)
export const firmlyBelieveHintFbSubmit = p => GETNEW('/studentgrowthfiles/studentPunishment/submit', p)

// 处分解除获取页面列表数据(弃用)
export const relieveGetTableData = p => POST('/studentgrowthfiles/studentPunishment/page/remove', p)

// 处分解除获取页面列表数据(弃用)
export const relieveGetDrawerData = p => POST('/studentgrowthfiles/studentPunishment/queryRemovePunishmentStudentInfo', p)

// 处分解除提交数据(弃用)
export const relieveSubmitDrawerData = p => POST('/studentgrowthfiles/studentPunishment/removePunishmentInfo', p)

// 新的处分解除提交数据
export const removePunishment = p => POST('/studentgrowthfiles/studentPunishment/removePunishment', p)

// 测试获取UserId(弃用)
export const getUserId = p => POST('/studentgrowthfiles/studentPunishment/getCurrentUserInfo', p)

// 获取详情
export const punishmentGetDetails = p => GETNEW('/studentgrowthfiles/studentPunishment/details', p)

// 处分管理页面导出
export const exportData = p => EXPORTNEW('/studentgrowthfiles/studentPunishment/export', p)


// 新的处分管理页面导出
export const exportDataNew = p => EXPORTNEW('/studentgrowthfiles/studentPunishment/exportPunishInfo', p)

// 处分统计页面导出
export const statisticsExportData = p => EXPORTNEW('/approval/print/pdf', p, 1)

// 处分批量下载审批单，认定书，解除书
export const batchPunishmentExportData = p => EXPORTNEW('/studentgrowthfiles/studentPunishment/downLoad', p, 1)

// 下发决定书
export const uploadLecisionLetter = p => GETNEW('/studentgrowthfiles/studentPunishment/sendDecisionBook', p)

// 处分解除验证
export const dischargePunishmenVerify = p => GETNEW('/studentgrowthfiles/studentPunishment/removeVerify', p)

// 修改处分解除配置
export const changePunishmentConfig = p => POSTNEW('/studentgrowthfiles/studentPunishment/updateIsRemove', p)

// 处分对比导入
// export const exportPunishmentComparison = p => POSTFormData('/studentgrowthfiles/studentPunishment/importExport', p)
export const exportPunishmentComparison = p => POSTFormData('/studentgrowthfiles/punishmentImport/importExport', p)

// 处分对比导出
export const punishmentComparisonExport = p => EXPORTNEW('/studentgrowthfiles/punishmentImport/exportPunishment', p)


// 查询流程节点信息接口
export const getInstanceInfo = p => POST('/studentgrowthfiles/studentPunishment/getInstanceInfo', p)


// WEBPACK FOOTER //
// ./src/api/modules/punishiment.js